module.exports = __webpack_public_path__ + "img/hero-5-mobile.32233268.jpg";